import { FC, PropsWithChildren } from 'react'
import { Lock } from 'lucide-react'

type LoginFormContainerProps = {
  title: string
  description: string
}
export const LoginFormContainer: FC<
  PropsWithChildren<LoginFormContainerProps>
> = props => {
  const { description, title } = props

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full space-y-8">
        {/* Header */}
        <div className="text-center">
          <div className="mx-auto h-12 w-12 bg-blue-600 rounded-full flex items-center justify-center">
            <Lock className="h-6 w-6 text-white" />
          </div>
          <h2 className="mt-6 text-3xl font-bold text-gray-900">{title}</h2>
          <p className="mt-2 text-sm text-gray-600">{description}</p>
        </div>

        {props.children}
      </div>
    </div>
  )
}
